import { render, staticRenderFns } from "./LittleGateLockDamage.vue?vue&type=template&id=51c4a718&scoped=true"
import script from "./LittleGateLockDamage.vue?vue&type=script&lang=ts"
export * from "./LittleGateLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4a718",
  null
  
)

export default component.exports